import React from 'react';
import './index.scss';
import IconUrl from '../../../../../../asset/User-Profile_Solid_E5E5E5_SVG.png'

const AssignSuccessScreen = (props) => {
  return (
    <div className="assign-confirmation-container">

      <img src={props.assignedUser?.thumbnailUrl || IconUrl} alt="Assigned User" className="assigned-avatar" />
      <div className="assigned-name">{props.assignedUser?.fullName}</div>
      <div className="assigned-email">{props.assignedUser?.email}</div>

      <p className="assigned-info">
        <span className="assigned-info-header">PRO SUBSCRIPTION</span>  <br />
        <span className="assigned-info-message">will be applied the next time they login or open the app.</span>
      </p>

      {/* <p className="assigned-note">
        You may cancel the update at any time.
      </p> */}
    </div>
  );
};

export default AssignSuccessScreen;
